import { SuperTicketType } from '@features/LotteryGame/types';
import { NumberSymbol, NumberSymbolGold } from '@assets/icons';
import { JSX } from 'react';

// Счастливые билеты
export const isLuckyTicket = (type?: SuperTicketType): boolean =>
  [
    SuperTicketType.TICKET_5,
    SuperTicketType.TICKET_10,
    SuperTicketType.TICKET_150,
    SuperTicketType.TICKET_240,
    SuperTicketType.TICKET_980,
    SuperTicketType.TICKET_2000,
  ].includes(type as SuperTicketType);

// Металлические билеты
export const isMetallicTicket = (type?: SuperTicketType): boolean =>
  [
    SuperTicketType.METALLIC_IRON_160,
    SuperTicketType.METALLIC_BRONZE_360,
    SuperTicketType.METALLIC_SILVER_560,
  ].includes(type as SuperTicketType);

export const getTicketLabelNode = (
  ticketType?: string,
  ticketNumber?: string,
): JSX.Element => {
  if (!ticketType) {
    return (
      <>
        Ticket <NumberSymbol />
        {ticketNumber}
      </>
    );
  }

  const type = ticketType as SuperTicketType;
  const isMetallic = isMetallicTicket(type);

  const label = isMetallic
    ? type.includes('IRON')
      ? 'Iron Ticket'
      : type.includes('BRONZE')
        ? 'Bronze Ticket'
        : 'Silver Ticket'
    : 'Lucky Ticket';

  const TicketIcon = isMetallic ? NumberSymbol : NumberSymbolGold;

  return (
    <>
      {label} <TicketIcon />
      {ticketNumber}
    </>
  );
};

export const getTicketLabelTextWinning = (ticketType?: SuperTicketType): string => {
  if (!ticketType) return 'Winners!';

  if (isMetallicTicket(ticketType)) {
    if (ticketType.includes('IRON')) return 'Iron Ticket Winners';
    if (ticketType.includes('BRONZE')) return 'Bronze Ticket Winners';
    if (ticketType.includes('SILVER')) return 'Silver Ticket Winners';
  }

  return 'Lucky Ticket Winners';
};

export const getTicketClassName = (ticketType?: SuperTicketType): string | undefined => {
  if (!ticketType) return;

  if (isLuckyTicket(ticketType)) {
    return 'tLuckyTicket';
  }

  if (isMetallicTicket(ticketType)) {
    if (ticketType.includes('IRON')) return 'tMetalTicketIron';
    if (ticketType.includes('BRONZE')) return 'tMetalTicketBronze';
    if (ticketType.includes('SILVER')) return 'tMetalTicketSilver';
  }

  return;
};

export const getTicketIconSrc = (ticketType?: SuperTicketType): string => {
  if (isMetallicTicket(ticketType)) {
    if (ticketType?.includes('IRON')) return 'images/dollar-iron.webp';
    if (ticketType?.includes('BRONZE')) return 'images/dollar-bronze.webp';
    if (ticketType?.includes('SILVER')) return 'images/dollar-silver.webp';
  }

  return 'images/dollar.webp';
};

export const getMetallicTicketLetter = (
  ticketType?: SuperTicketType,
): 'I' | 'B' | 'S' | 'L' | undefined => {
  if (!ticketType) return;

  if (isLuckyTicket(ticketType)) {
    return 'L';
  }

  if (isMetallicTicket(ticketType)) {
    if (ticketType.includes('IRON')) return 'I';
    if (ticketType.includes('BRONZE')) return 'B';
    if (ticketType.includes('SILVER')) return 'S';
  }

  return;
};

export const getTicketLabelImage = (ticketType?: SuperTicketType): string | undefined => {
  if (!ticketType) return;

  if (isLuckyTicket(ticketType)) {
    return '/images/tableBackgrounds/navPopup/luckyPopup.webp';
  }

  if (isMetallicTicket(ticketType)) {
    if (ticketType.includes('IRON')) {
      return '/images/tableBackgrounds/navPopup/ironPopup.webp';
    }
    if (ticketType.includes('BRONZE')) {
      return '/images/tableBackgrounds/navPopup/bronzePopup.webp';
    }
    if (ticketType.includes('SILVER')) {
      return '/images/tableBackgrounds/navPopup/silverPopup.webp';
    }
  }

  return;
};
